// src/pages/etc/mailAlert/naverMailSearchUrl.js
// ✅ "메일 확인" 버튼용 — 개별 메일 직링크는 네이버가 지원하지 않아, 제목을
// 검색어로 넣은 네이버 메일 검색 결과 URL을 새 탭으로 연다.
// ⚠️ 이 URL 포맷은 실제 로그인된 네이버 메일 화면에서 실측 검증되지 않았다(이
// 세션엔 브라우저 도구가 없었음) — 최선 추정 포맷이며, 동작하지 않으면 기본
// 진입(mail.naver.com)으로 폴백한다. 실메일 테스트 때 "메일 확인" 버튼을 눌러
// 정상 도달하는지 확인하고, 안 맞으면 이 파일의 URL 포맷만 고치면 된다.
export const NAVER_MAIL_FALLBACK_URL = "https://mail.naver.com";

export function buildNaverMailSearchUrl(subject) {
  const q = (subject || "").trim();
  if (!q) return NAVER_MAIL_FALLBACK_URL;
  try {
    return `https://mail.naver.com/v2/search/all?query=${encodeURIComponent(q)}`;
  } catch {
    return NAVER_MAIL_FALLBACK_URL;
  }
}
